import styled from "styled-components";

export const ModalSucessoContainer = styled.div`
  padding: 30px 0;

  .mensagem {
    margin-bottom: 30px;
    font-family: 'Inter';
    color: ${(props) => props.theme.colors.tertiary};
    font-weight: bold;
  }
`;
